import { Document, Page, View, StyleSheet } from "@react-pdf/renderer";
import React from "react";
import {
  Table,
  TableHeader,
  TableCell,
  TableBody,
  DataTableCell,
} from "@david.kucsai/react-pdf-table";

// import { numberWithCommas } from "../../../helpers/dataHelpers";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    fontSize: 10,
  },
  section: {
    margin: 1,
    padding: 10,
    flexGrow: 1,
    fontSize: 10,
  },
});

export const InventoryDetailsPdfToRenderOverallComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Cluster Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>Active Pcs</TableCell>
            <TableCell>Active Amt</TableCell>
            <TableCell>Overdue Pcs</TableCell>
            <TableCell>Overdue Amt</TableCell>
            <TableCell>% OD Pcs</TableCell>
            <TableCell>% OD Amt</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pcs</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.clusterName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetails.active} />
            <DataTableCell getContent={(r) => r.totalPrincipalDetails.active} />
            <DataTableCell getContent={(r) => r.totalPiecesDetails.expired} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expired}
            />
            <DataTableCell
              getContent={(r) => r.totalPiecesDetails.expiredPercentage}
            />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expiredPercentage}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);

export const InventoryDetailsPdfToRenderAreaComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Area Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>Active Pcs</TableCell>
            <TableCell>Active Amt</TableCell>
            <TableCell>Overdue Pcs</TableCell>
            <TableCell>Overdue Amt</TableCell>
            <TableCell>% OD Pcs</TableCell>
            <TableCell>% OD Amt</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pcs</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.areaName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetails.active} />
            <DataTableCell getContent={(r) => r.totalPrincipalDetails.active} />
            <DataTableCell getContent={(r) => r.totalPiecesDetails.expired} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expired}
            />
            <DataTableCell
              getContent={(r) => r.totalPiecesDetails.expiredPercentage}
            />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expiredPercentage}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);

export const InventoryDetailsPdfToRenderBranchComponent = (data) => (
  <Document>
    <Page wrap={true} orientation="landscape" size="A4" style={styles.page}>
      <View wrap={true}>
        <Table data={data}>
          <TableHeader>
            <TableCell>Branch Name</TableCell>
            {/* <TableCell># of Branches</TableCell> */}
            <TableCell>Active Pcs</TableCell>
            <TableCell>Active Amt</TableCell>
            <TableCell>Overdue Pcs</TableCell>
            <TableCell>Overdue Amt</TableCell>
            <TableCell>% OD Pcs</TableCell>
            <TableCell>% OD Amt</TableCell>
            <TableCell>Total Pcs</TableCell>
            <TableCell>Total Amt</TableCell>
            <TableCell>Ave/Amt/Pcs</TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell
              textAlign={"center"}
              getContent={(r) => r.branchName}
            />
            {/* <DataTableCell getContent={(r) => r.branchCount} /> */}
            <DataTableCell getContent={(r) => r.totalPiecesDetails.active} />
            <DataTableCell getContent={(r) => r.totalPrincipalDetails.active} />
            <DataTableCell getContent={(r) => r.totalPiecesDetails.expired} />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expired}
            />
            <DataTableCell
              getContent={(r) => r.totalPiecesDetails.expiredPercentage}
            />
            <DataTableCell
              getContent={(r) => r.totalPrincipalDetails.expiredPercentage}
            />
            <DataTableCell getContent={(r) => r.totalPieces} />
            <DataTableCell getContent={(r) => r.totalPrincipal} />
            <DataTableCell getContent={(r) => r.averagePrincipalPerPiece} />
          </TableBody>
        </Table>
      </View>
    </Page>
  </Document>
);
